import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';
import {useSelector} from "../redux/store";

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const {isAuthenticated} = useSelector((state) => state.user);

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}
